(function (angular) {
  "use strict";

  angular.module("app").directive("optionSelect", optionSelect);

  optionSelect.$inject = ["$timeout"];

  function optionSelect($timeout) {
    function optionSelectLink($scope) {
      $scope.selectOption = selectOption;

      function selectOption(option) {
        $scope.ngModel = option.value;

        if ($scope.onChange) {
          $timeout(function () {
            $scope.onChange.call(option.value);
          });
        }
      }
    }

    return {
      templateUrl: "directives/option-select.html",
      scope: {
        options: "=", // eg [{ value: true, label: 'Yes' }, { value: false, label: 'No' }, {...}]
        ngModel: "=",
        onChange: "=?",
      },
      link: optionSelectLink,
    };
  }
})(angular);
